import { FrownOutlined } from "@ant-design/icons";
import { notification } from "antd";

/**
 * Handles creating or updating a zone with associated systems and devices.
 */
async function useHandlePropertyZoneUpdate(
  formValues,
  createZoneMutation,
  editZoneMutation,
  manageZoneMutation,
  zoneSerialNumber,
  setIsFormDirty,
  setIsLoading,
) {
  const { ZoneName, Systems } = formValues ?? {};
  const { AssignedSystems = [] } = Systems ?? {};

  const showNotification = (type, message, description = "") => {
    notification[type]({
      message: <span className="uppercase tracking-widest">{message}</span>,
      description,
      duration: type === "success" ? 2 : 5,
      placement: "topRight",
      icon:
        type === "error" ? (
          <FrownOutlined className="text-triple-red" />
        ) : undefined,
    });
  };

  try {
    if (zoneSerialNumber) {
      // Edit existing zone name
      await editZoneMutation.mutateAsync({
        zoneSerialNumber,
        data: {
          Name: ZoneName,
          ImageUrl: "",
        },
      });

      const systemsWithDevices = AssignedSystems.map((system) => ({
        systemId: system.UniqueId,
        deviceSerialNumbers:
          system.children?.map((child) => child.SerialNumber) ?? [],
      }));

      await manageZoneMutation.mutateAsync({
        zoneSerialNumber,
        data: {
          SystemsWithDevices: systemsWithDevices,
        },
      });
    } else {
      const systemsWithDevices = AssignedSystems.map((system) => ({
        systemId: system.UniqueId,
        deviceSerialNumbers:
          system.children?.map((child) => child.SerialNumber) ?? [],
      }));

      await createZoneMutation.mutateAsync({
        Name: ZoneName,
        Location: null, // TODO: Add Location
        SystemsWithDevices: systemsWithDevices,
      });
    }

    showNotification("success", "Zone update success");
    return { createZoneResponse: Systems };
  } catch (error) {
    const message =
      error?.response?.data?.Errors?.[0] ??
      error?.message ??
      "Something went wrong!";
    showNotification("error", message, "Could not update zone.");
    return { error };
  } finally {
    setIsLoading(false);
    setIsFormDirty(false);
  }
}

export default useHandlePropertyZoneUpdate;
